module.exports = __webpack_public_path__ + "img/Time-to-Dance.98b7b93a.jpg";